import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    loading: true,
    imagePolicies: [],
    imagePoliciesPagination: {},
    imagePolicy: {},
    fetchingPolicies: false,
    addingPolicy: false,
    removingPolicy: false,
    updatingPolicy: false,
    gettingPolicy: false,
  },
  mutations: {
    // API
    SET_IMAGEPOLICIES(state, data) {
      state.imagePolicies = data.result
      state.imagePoliciesPagination = data.resultInfo
    },
    GET_IMAGEPOLICY(state, data) {
      state.imagePolicy = data
    },
    // this.$store.commit('SET_IMAGEPOLICY', value)
    SET_IMAGEPOLICY(state, data) {
      state.imagePolicy = data
    },
    SET_FETCHING_IMAGEPOLICIES(state, value) {
      state.fetchingPolicies = value
    },
    SET_ADDING_IMAGEPOLICY(state, value) {
      state.addingPolicy = value
    },
    SET_REMOVING_IMAGEPOLICY(state, value) {
      state.removingPolicy = value
    },
    REMOVE_IMAGEPOLICY(state, id) {
      state.imagePolicies = state.imagePolicies.filter(u => u.id !== id)
    },
    SET_GETTING_IMAGEPOLICY(state, value) {
      state.gettingPolicy = value
    },
    SET_UPDATING_IMAGEPOLICY(state, value) {
      state.updatingPolicy = value
    },
  },
  actions: {
    fetchImagePolicies({ commit }, payload) {
      const query = `?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`
      commit('SET_FETCHING_IMAGEPOLICIES', true)
      return new Promise((resolve, reject) => {
        api('cdn').get(`/projects/${projectId()}/image_policies${query}`)
          .then(response => {
            commit('SET_IMAGEPOLICIES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_IMAGEPOLICIES', false) })
      })
    },
    // this.$store.dispatch('addImagePolicy', query)

    addImagePolicy({ commit }, query) {
      commit('SET_ADDING_IMAGEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').post(`/projects/${projectId()}/image_policies`, query)
          .then(response => {
            commit('SET_IMAGEPOLICY', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_IMAGEPOLICY', false) })
      })
    },

    updateImagePolicy({ commit }, query) {
      commit('SET_UPDATING_IMAGEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').put(`/projects/${projectId()}/image_policies/${query.id}`, query)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_IMAGEPOLICY', false) })
      })
    },

    removeImagePolicy({ commit }, id) {
      commit('SET_REMOVING_IMAGEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').delete(`/projects/${projectId()}/image_policies/${id}`)
          .then(response => {
            commit('REMOVE_IMAGEPOLICY', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_IMAGEPOLICY', false) })
      })
    },

    getImagePolicy({ commit }, id) {
      commit('SET_GETTING_IMAGEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').get(`/projects/${projectId()}/image_policies/${id}`)
          .then(response => {
            commit('GET_IMAGEPOLICY', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_IMAGEPOLICY', false) })
      })
    },
  },
}
